import React from 'react';
import { Button } from './ui/button';
import { X } from 'lucide-react';

export const LegalNoticeEn = ({ onClose }) => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Legal Notice and Terms of Use</h1>
        <Button onClick={onClose} variant="outline" size="sm">
          <X className="h-4 w-4" />
        </Button>
      </div>
      
      <div className="space-y-6 text-gray-700">
        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">Website Owner</h2>
          <p className="mb-4">
            This website (hereinafter, the "Website") is owned by <strong>Ulysse Julien Berneau</strong>, with NIE Y5618264E, domiciled at Calle Castillejos 276, SA2A, 08025 Barcelona (Spain), general contact email info@agencia-ppc.es, phone +34 613 076 099 and specific email for data protection rgpd@agencia-ppc.es.
          </p>
          <p className="mb-4">
            <strong>Trade name:</strong> ArrancaYa BCN and Agencia PPC.<br/>
            <strong>Main domain:</strong> arrancaya-bcn.es agencia-ppc.es
          </p>
        </section>

        <section className="bg-blue-50 border border-blue-200 p-4 rounded-lg">
          <h2 className="text-xl font-semibold mb-3 text-gray-900">Nature of the service: matchmaking platform</h2>
          <p className="mb-3">
            ArrancaYa BCN is a <strong>matchmaking and lead-connection platform</strong> that connects Users who need a vehicle jump-start service with <strong>independent, certified assistance technicians and professionals</strong> operating on their own account.
          </p>
          <p className="mb-3">
            <strong>Ulysse Julien Berneau is solely and exclusively responsible for the website</strong> (its content, operation and the connection service). <strong>He does not provide the jump-start service directly.</strong> The physical intervention, its execution, quality, timing and billing are entirely the responsibility of the independent technician who handles each request.
          </p>
          <p>
            Consequently, the Website Owner assumes no responsibility for the actual provision of the service or for any damage, delay or incident arising from the intervention of the independent technicians, who act as the sole providers and responsible parties towards the User.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">1. Purpose and scope of application</h2>
          <p className="mb-4">
            This Legal Notice regulates access, navigation and use of the Website, as well as the responsibilities derived from the use of its contents (understanding "contents" as texts, graphics, logos, trademarks, photographs, software, codes, designs, interfaces, as well as any other protected creation), in accordance with applicable Spanish regulations, in particular Law 34/2002, of July 11, on information society and electronic commerce services (LSSI), and other complementary legislation.
          </p>
          <p>
            Access or use of the Website confers the status of User and implies full and unreserved acceptance of all the provisions of this Legal Notice in the version published at any given time. If you do not agree with the terms set forth herein, please refrain from using the Website.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">2. Access and use conditions of the Website</h2>
          <ul className="list-disc ml-6 space-y-2">
            <li>Access to the Website is, in general, free and gratuitous. However, some services may be subject to contracting and payment of a price in accordance with the Service Conditions that will be published and accepted before contracting.</li>
            <li>The User undertakes to make diligent, correct and lawful use of the Website and its contents, and not to use them for illicit, prohibited purposes or harmful to the rights and interests of third parties, or that in any way may damage, disable, overload or deteriorate the Website or prevent its normal use.</li>
            <li>The User undertakes not to introduce or disseminate computer viruses or any physical or logical systems that are capable of causing damage to the systems of the Owner or third parties.</li>
            <li>The User is obliged not to use false identities or impersonate the identity of others in the use of the Website or in the use of any of its services, including the WhatsApp channel.</li>
            <li>When the User provides data through forms or WhatsApp, declares that all the information provided is true, accurate, current and complete. The User will be solely responsible for any damages that may be caused to the Owner or third parties by providing false, inaccurate, outdated or incomplete data.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">13. Contact</h2>
          <p>
            For any inquiry related to the content of this Legal Notice, you can contact the Owner at info@agencia-ppc.es or at phone +34 613 076 099. For privacy matters, write to rgpd@agencia-ppc.es.
          </p>
        </section>
      </div>
    </div>
  );
};

export const PrivacyPolicyEn = ({ onClose }) => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Privacy Policy</h1>
        <Button onClick={onClose} variant="outline" size="sm">
          <X className="h-4 w-4" />
        </Button>
      </div>
      
      <div className="space-y-6 text-gray-700">
        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">1. Data Controller</h2>
          <p className="mb-4">
            <strong>Controller:</strong> Ulysse Julien Berneau<br/>
            <strong>NIE:</strong> Y5618264E<br/>
            <strong>Address:</strong> Calle Castillejos 276, SA2A, 08025 Barcelona (Spain)<br/>
            <strong>General email:</strong> info@agencia-ppc.es<br/>
            <strong>GDPR email:</strong> rgpd@agencia-ppc.es<br/>
            <strong>Phone:</strong> +34 613 076 099<br/>
            <strong>Trade names:</strong> ArrancaYa BCN and Agencia PPC
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">2. Personal Data We Collect</h2>
          <p className="mb-3">We collect the following types of personal data:</p>
          <ul className="list-disc ml-6 space-y-2">
            <li><strong>Identification and contact data:</strong> Name, phone, email, service location</li>
            <li><strong>Vehicle information:</strong> Brand, model and technical details necessary for the service</li>
            <li><strong>Navigation data:</strong> IP address, cookies, device information, pages visited</li>
            <li><strong>WhatsApp communications:</strong> Messages, metadata and conversation content for service management</li>
            <li><strong>Contracting data:</strong> Information necessary for service provision and billing</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">8. User Rights</h2>
          <p className="mb-3">You can exercise the following rights:</p>
          <ul className="list-disc ml-6 space-y-2">
            <li><strong>Access:</strong> Know what data we process about you</li>
            <li><strong>Rectification:</strong> Correct inaccurate or incomplete data</li>
            <li><strong>Erasure:</strong> Request deletion of your data</li>
            <li><strong>Restriction:</strong> Restrict processing in certain circumstances</li>
            <li><strong>Portability:</strong> Receive your data in structured format</li>
            <li><strong>Objection:</strong> Object to processing based on legitimate interest</li>
            <li><strong>Withdrawal of consent:</strong> At any time</li>
          </ul>
          <p className="mt-3">
            To exercise these rights, contact rgpd@agencia-ppc.es. You can also file a complaint with the Spanish Data Protection Agency (www.aepd.es).
          </p>
        </section>
      </div>
    </div>
  );
};

export const TermsConditionsEn = ({ onClose }) => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-gray-900">General Terms of Service</h1>
        <Button onClick={onClose} variant="outline" size="sm">
          <X className="h-4 w-4" />
        </Button>
      </div>
      
      <div className="space-y-6 text-gray-700">
        <div className="bg-gray-50 p-4 rounded-lg">
          <p className="font-medium text-gray-900 mb-2">ArrancaYa BCN – Ulysse Julien Berneau (NIE Y5618264E)</p>
          <p className="text-sm space-y-1">
            <span className="block"><strong>Address:</strong> Calle Castillejos 276, SA2A, 08025 Barcelona (Spain)</span>
            <span className="block"><strong>Contact:</strong> info@agencia-ppc.es · +34 613 076 099</span>
            <span className="block"><strong>Privacy:</strong> rgpd@agencia-ppc.es</span>
            <span className="block"><strong>Domain:</strong> arrancaya-bcn.es</span>
          </p>
        </div>

        <p className="text-sm italic">
          These Terms regulate the use of the website as a matchmaking platform that connects the User with independent, certified technicians who provide the 12V jump-start service at home in Barcelona (hereinafter, the "Service"). The website owner acts solely as an intermediary and does not provide the Service directly. They are complementary to the Legal Notice, Privacy Policy and Cookie Policy.
        </p>

        <hr className="border-gray-300" />

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">1. Service Object</h2>
          <div className="space-y-3">
            <p><strong>1.1.</strong> ArrancaYa BCN is a matchmaking platform that connects the User with independent, certified technicians. It is these technicians who provide, on their own account, the vehicle jump-start assistance using 12V booster equipment, basic battery diagnosis and charge voltage verification with the engine running. The website owner does not execute, supervise or take part in the Service.</p>
            <p><strong>1.2.</strong> <strong>Scope:</strong> passenger cars, SUVs and light vans (≤3,500 kg). Diesel/gasoline vehicles with 12V system.</p>
            <p><strong>1.3.</strong> <strong>Exclusions:</strong> no towing, component replacement on public roads (except agreed spot supplies), or interventions on high voltage systems (electric/hybrid vehicles: only 12V auxiliary battery).</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">5. Prices, supplements and taxes</h2>
          <div className="space-y-3">
            <p><strong>5.1.</strong> <strong>Indicative base rate of the technician network</strong> published on the website (final prices are set and applied by the independent technicians who provide the Service):</p>
            <ul className="list-disc ml-8 space-y-1">
              <li>Day (07:30–22:00): €69 VAT incl.</li>
              <li>Night / weekend / holidays: €89–99 VAT incl.</li>
            </ul>
            <p><strong>5.3.</strong> <strong>If it doesn't start, it's FREE:</strong> when, after acting in accordance with §1 and §4, the vehicle does not start, nothing is charged (€0).</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-gray-900">6. Liability</h2>
          <div className="space-y-3">
            <p><strong>6.1.</strong> The website owner acts solely as a matchmaking platform. The provision of the Service, its quality, safety, timing and results are the sole and exclusive responsibility of the independent technician who intervenes. Billing is also carried out directly by that technician. The website owner is in no case liable for any damage, delay or incident arising from the technicians' intervention.</p>
          </div>
        </section>

        <div className="text-center text-sm text-gray-500 bg-gray-50 p-3 rounded">
          <strong>Last updated:</strong> 17/09/2026
        </div>
      </div>
    </div>
  );
};